module.exports = __webpack_public_path__ + "static/media/003.8756fcb3.jpg";